module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"resendActivationEmail":"Resend Activation Email"},"al":{"resendActivationEmail":"Ridërgo Emailin e Aktivizimit"}}')
  delete Component.options._Ctor
}
